import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { EnvConfig } from './types/env-config.interface';
import { EnvConfigImpl } from './env-config';
export const baseConfig = new ContainerModule(bind => {
    bind(EnvConfig).toConstantValue(new EnvConfigImpl());
});
